__turbopack_context__.v({
  "container": "ColorThemeProvider-module-scss-module__TLc0gq__container",
});
